/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Error_RequiredInputs */

const en_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This field is required.`)
};

const de_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Feld ist erforderlich.`)
};

const fr_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce champ est obligatoire.`)
};

const es_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este campo es obligatorio.`)
};

const it_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo campo è obbligatorio.`)
};

const nl_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit veld is verplicht.`)
};

const pl_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To pole jest wymagane.`)
};

const fi_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä kenttä on pakollinen.`)
};

const da_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette felt er påkrævet.`)
};

const sv_consumer_declaration_error_required = /** @type {(inputs: Consumer_Declaration_Error_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fältet är obligatoriskt.`)
};

/**
* | output |
* | --- |
* | "This field is required." |
*
* @param {Consumer_Declaration_Error_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_error_required = /** @type {((inputs?: Consumer_Declaration_Error_RequiredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Error_RequiredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_error_required(inputs)
	if (locale === "fr") return fr_consumer_declaration_error_required(inputs)
	if (locale === "es") return es_consumer_declaration_error_required(inputs)
	if (locale === "it") return it_consumer_declaration_error_required(inputs)
	if (locale === "nl") return nl_consumer_declaration_error_required(inputs)
	if (locale === "pl") return pl_consumer_declaration_error_required(inputs)
	if (locale === "fi") return fi_consumer_declaration_error_required(inputs)
	if (locale === "da") return da_consumer_declaration_error_required(inputs)
	if (locale === "sv") return sv_consumer_declaration_error_required(inputs)
	return en_consumer_declaration_error_required(inputs)
});